import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../store/redux';
import {
  filtersData,
  IFiltersData,
} from '../../shopListingBottomSheet/utils/index';
import {findOffers} from '../../../../store/redux/offers';

const FiltersOffersList = ({inputGroupName}: {inputGroupName?: string}) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.offers);

  // const {data} = useGetRange(
  //   inputGroupList?.find(item => item.title === inputGroupName)?.guid,
  // );

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center  gap-2">
        {state.input_guid?.map(item => (
          <div
            className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap"
            key={item.guid}
          >
            {item.title}
            <i
              className="icon-nameClose-remove mr-3 text-lg"
              onClick={() =>
                dispatch(
                  findOffers({
                    ...state,
                    input_guid: state.input_guid?.filter(
                      elem => elem.guid !== item.guid,
                    ),
                  }),
                )
              }
            />
          </div>
        ))}
      </div>
      {state.order_by && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <i
            className="icon-nameClose-remove mr-3 text-lg "
            onClick={() => dispatch(findOffers({...state, order_by: ''}))}
          />
          <span>
            {
              filtersData.find(
                (item: IFiltersData) => item.value === state.order_by,
              )?.title
            }
          </span>
        </div>
      )}

      {state.has_store === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>آگهی فروشگاه ها </span>
          <i
            className="icon-nameClose-remove mr-3 text-lg"
            onClick={() => dispatch(findOffers({...state, has_store: false}))}
          />
        </div>
      )}

      {state.has_price === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>آگهی های دارای قیمت </span>
          <i
            className="icon-nameClose-remove mr-3 text-lg"
            onClick={() => dispatch(findOffers({...state, has_price: false}))}
          />
        </div>
      )}
      {state?.start_price > 0 && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span> از قیمت {state.start_price}</span>
          <i
            className="icon-nameClose-remove mr-3 text-lg"
            onClick={() => {
              dispatch(
                findOffers({
                  ...state,
                  start_price: 0,
                }),
              );
            }}
          />
        </div>
      )}
      {state?.end_price < 999000000 && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span> تا قیمت {state?.end_price}</span>
          <i
            className="icon-nameClose-remove mr-3 text-lg"
            onClick={() => {
              dispatch(
                findOffers({
                  ...state,
                  end_price: 999000000,
                }),
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FiltersOffersList;
